/**
 * Initials for a person's display name: the first letter of up to two words,
 * uppercase — "Jane Nguyen" → "JN", "Cher" → "C" — and "?" when there is no
 * name, so an avatar never renders empty. The single rule for every initials
 * avatar in Orbit (TeammateAvatar, IdentityRow leading slots).
 */
export function getPersonInitials(name: string | undefined | null): string {
  if (!name) {
    return '?';
  }
  return (
    name
      .trim()
      .split(/\s+/)
      .map((part) => part[0])
      .filter(Boolean)
      .slice(0, 2)
      .join('')
      .toUpperCase() || '?'
  );
}
